import { getSupportChannelTypes } from '@/tools';

/** 媒体渠道枚举getter */
const channel_getters = getSupportChannelTypes().reduce((previous_value, current_value) => {
  return Object.assign(previous_value, {
    [`${current_value}Enum`]: state => state.enum[current_value],
    [`${current_value}EnumVal`]: state => state.enum[`${current_value}_enum`],
  });
}, {});

const getters = Object.assign({
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  userId: state => state.user.id,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  gdtLabel: state => state.label.gdt,
}, channel_getters);

export default getters;
